module.exports = __webpack_public_path__ + "img/SIPPEREC_NEWLOGO.d67278c3.png";